import { CREATE } from '@/constants/api'

export const EXPENSES = 'expenses'
export const CATEGORIES = 'categories'

export const ENDPOINTS = {
  // Stock (actual inventory quantities per church)
  LIST_EXPENSES: `/${EXPENSES}`,
  EXPENSE: `/${EXPENSES}`,
  CREATE_EXPENSE: `/${EXPENSES}/${CREATE}`,

  // Categories
  LIST_CATEGORIES: `/${EXPENSES}/${CATEGORIES}`,
  CATEGORY: `/${EXPENSES}/${CATEGORIES}`,
  CREATE_CATEGORY: `/${EXPENSES}/${CATEGORIES}/${CREATE}`,
}
